/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ServiceordreStateWithDisplayTextDto as OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto } from '../models/OK/Egis/Service/Models/DTO/serviceordre-state-with-display-text-dto';

@Injectable({
  providedIn: 'root',
})
export class ServiceordreStateService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllServiceOrdreStates
   */
  static readonly GetAllServiceOrdreStatesPath = '/api/v1/ServiceordreState/GetServiceordreStates';

  /**
   * Get all ServiceordreStates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllServiceOrdreStates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllServiceOrdreStates$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ServiceordreStateService.GetAllServiceOrdreStatesPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto>>;
      })
    );
  }

  /**
   * Get all ServiceordreStates.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllServiceOrdreStates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllServiceOrdreStates(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto>> {

    return this.getAllServiceOrdreStates$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceordreStateWithDisplayTextDto>)
    );
  }

}
